// @core/api/endpoints/calendar/get_booking_link.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingLinkResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Get booking link
 * Retrieves booking link configuration including availability, duration, and form questions.
 */
export async function GetBookingLink(
  link_id: string,
  options?: RequestOptions
): Promise<BookingLinkResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking-links/:link_id`;
  requestPath = requestPath.replace(':link_id', encodeURIComponent(link_id));
  const requestOptions = options;
  return client.get<BookingLinkResponse>(requestPath, { ...requestOptions });
}
